module.exports = __webpack_public_path__ + "img/class-banner1.ccd4ada.png";